import autobind from 'autobind';

import { assertIsDefined } from '@utils/assertIsDefined';

const SUBSCRIBE_URL = '/api/event/subscribe';

export class ServerEventBus {
    private static instance: ServerEventBus;

    public static getInstance(): ServerEventBus {
        if (!this.instance) {
            this.instance = new ServerEventBus();
        }

        this.instance.init();

        return this.instance;
    }

    private eventCallbacks: Map<string, (data?: any) => void> = new Map();
    private eventSource?: EventSource;

    private constructor() {}

    public init(): void {
        if (!this.eventSource) {
            this.eventSource = new EventSource(SUBSCRIBE_URL);
        }
    }

    public addEventListener(eventType: string, cb: any): void {
        this.eventCallbacks.set(eventType, cb);
        // @ts-expect-error
        this.eventSource.addEventListener(eventType, this.onMessage);
    }

    public removeEventListener(eventType: string): void {
        this.eventCallbacks.delete(eventType);
        // @ts-expect-error
        this.eventSource.removeEventListener(eventType, this.onMessage);
    }

    public close(): void {
        this.eventCallbacks.forEach((_, eventType) => {
            // @ts-expect-error
            this.eventSource.removeEventListener(eventType, this.onMessage);
        });
        this.eventCallbacks.clear();
        this.eventSource?.close();
        this.eventSource = undefined;
    }

    @autobind
    protected onMessage(event: MessageEvent): void {
        const data = JSON.parse(event.data);
        const callback = this.eventCallbacks.get(event.type);
        assertIsDefined(callback, `Server event ${event.type} is dispatched only for a registered callback`);

        callback(data);
    }
}
